import axios from 'axios'
import { getSavedState, saveState } from '../store-utils'
import EventBus from '@utils/app/event-bus'

export const state = {
  cachedEventCurrents: getSavedState('device.eventCurrents'),
}

export const getters = {
  cachedEventCurrents(state) {
    return state.cachedEventCurrents
  },

  cachedEventCurrentsWithFilters(state, getters, rootState) {
    let cachedEventCurrentsWithFilters = [...(state.cachedEventCurrents || [])]

    if (!rootState.filters.device.showRunning) {
      cachedEventCurrentsWithFilters = cachedEventCurrentsWithFilters.filter(function(
        deviceEvent
      ) {
        return deviceEvent.status.type !== 1
      })
    }

    if (!rootState.filters.device.showIdle) {
      cachedEventCurrentsWithFilters = cachedEventCurrentsWithFilters.filter(function(
        deviceEvent
      ) {
        return deviceEvent.status.type !== 0
      })
    }

    if (rootState.filters.device.name) {
      if (rootState.filters.device.searchGroup) {
        cachedEventCurrentsWithFilters = cachedEventCurrentsWithFilters.filter(
          (deviceEvent) => {
            return deviceEvent.device.group.name
              .toUpperCase()
              .includes(rootState.filters.device.name)
          }
        )
      } else {
        cachedEventCurrentsWithFilters = cachedEventCurrentsWithFilters.filter(
          (deviceEvent) => {
            return deviceEvent.device.name
              .toUpperCase()
              .includes(rootState.filters.device.name)
          }
        )
      }
    }

    return cachedEventCurrentsWithFilters
  },
}

export const mutations = {
  SET_CACHE(state, eventCurrents) {
    state.cachedEventCurrents = eventCurrents
    saveState('device.eventCurrents', eventCurrents)
  },
}

export const actions = {
  fetchEventCurrents({ commit, state, rootState }, { clearCache }) {
    // 1. Check if we've already fetched and cachedGroups the activity groups.
    const cachedEventCurrents = state.cachedEventCurrents

    if (!clearCache && cachedEventCurrents) {
      EventBus.$emit('device-state-set-interval', {})
      return Promise.resolve(cachedEventCurrents)
    }

    // 2. Fetch the eventCurrents from the API and cache it in case
    // we need it again in the future.
    return axios.get('/api/services/app/DeviceEvent/GetAllCurrent').then((response) => {
      const eventCurrents = response.data.items
      if (eventCurrents.length > 0) {
        commit('SET_CACHE', eventCurrents)
      }
      EventBus.$emit('device-state-set-interval', {})
      return eventCurrents
    })
  },
}
